import {
  FeatureTileDto,
  FeatureTilesApi,
  FeatureTilesCreateTilePostRequest,
  FeatureTilesDeleteTileRequest,
  FeatureTilesReorderTilesPostRequest,
  FeatureTilesUpdateTilePutRequest,
  InitOverrideFunction,
} from "../../../@api";

export class FeatureTilesApiService
  implements Omit<FeatureTilesApi, `${string}Raw` | "withMiddleware" | "withPreMiddleware" | "withPostMiddleware">
{
  constructor(private readonly api: FeatureTilesApi) {}

  public featureTilesCreateTilePost(
    requestParameters?: FeatureTilesCreateTilePostRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<FeatureTileDto> {
    return this.api.featureTilesCreateTilePost(requestParameters, initOverrides);
  }
  public featureTilesDeleteTile(
    requestParameters: FeatureTilesDeleteTileRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<void> {
    return this.api.featureTilesDeleteTile(requestParameters, initOverrides);
  }
  public featureTilesGetAllCustomTiles(
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<Array<FeatureTileDto>> {
    return this.api.featureTilesGetAllCustomTiles(initOverrides);
  }
  public featureTilesGetPortalTiles(
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<Array<FeatureTileDto>> {
    return this.api.featureTilesGetPortalTiles(initOverrides);
  }
  public featureTilesReorderTilesPost(
    requestParameters?: FeatureTilesReorderTilesPostRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<void> {
    return this.api.featureTilesReorderTilesPost(requestParameters, initOverrides);
  }
  public featureTilesUpdateTilePut(
    requestParameters: FeatureTilesUpdateTilePutRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<FeatureTileDto> {
    return this.api.featureTilesUpdateTilePut(requestParameters, initOverrides);
  }
}
